import { WorkspaceMemberFeature } from '#app/__generated__/api.js';
import { useCurrentUser } from '#app/hooks/useCurrentUser.js';

export const useHasWorkspaceMemberFeature = (
  workspaceMemberFeature: WorkspaceMemberFeature,
): boolean => {
  const currentUser = useCurrentUser();

  const hasFeature = Boolean(
    currentUser?.workspaceForSelectedUserType.visitorMember?.enabledFeatures?.includes(
      workspaceMemberFeature,
    ),
  );

  return hasFeature;
};
